import { Factory } from 'miragejs';
import { faker } from '@faker-js/faker';

export default Factory.extend({
	authorizationNumber: () => faker.string.uuid(),
	commerce: () => faker.company.name(),
	totalNetAmount: () => ({
		amount: () => parseFloat(faker.finance.amount()),
		currency: {
			id: 'EUR',
			code: '978',
		},
	}),
	registrationDate: () => faker.date.recent().toISOString(),
	operationCode: () => String(faker.number.int({ min: 1, max: 9999999 })).padStart(7, '0'),
	deferralType: '7050',
	openingFee: () => ({
		amount: () => parseFloat(faker.finance.amount()),
		currency: {
			id: 'EUR',
			code: '978',
		},
	}),
	agreement: () => String(faker.number.int({ min: 10000, max: 99999 })),
	paymentInterest: () => ({
		amount: parseFloat(faker.finance.amount()),
		currency: {
			id: 'EUR',
			code: '978',
		},
	}),
	//La amortización parcial no puede superar pendingCapitalAmount
	pendingCapitalAmount: () => ({
		amount: () => faker.number.int({ min: 100, max: 500 }),
		currency: {
			id: 'EUR',
			code: '978',
		},
	}),
	paymentAmount: {
		amount: 1.5,
		currency: {
			id: 'EUR',
			code: '978',
		},
	},
	pendingInterest: {
		amount: () => parseFloat(faker.finance.amount()),
		currency: {
			id: 'EUR',
			code: '978',
		},
	},
	amortisationTotalAmount: {
		amount: parseFloat(faker.finance.amount()),
		currency: {
			id: 'EUR',
			code: '978',
		},
	},
	fundingNumber: () => faker.number.int({ min: 1, max: 10 }),
	purchaseStatus: () => faker.helpers.arrayElement([1, 3]),
	purchaseRegistrationDate: () => faker.date.recent().toISOString(),
	panToken: () => faker.string.uuid(),
	settlementDate: () => faker.date.recent().toISOString(),
	apr: 0,
	amortisationFeeAmount: 0,
	invoicedAmount: {
		amount: () => parseFloat(faker.finance.amount()),
		currency: {
			id: 'EUR',
			code: '978',
		},
	},
	paymentDeadlines: '7050',
	pendingPayments: () => faker.number.int({ min: 0, max: 100 }),
});
